module.exports = __webpack_public_path__ + "img/PennyInBergen.a898d9ce.svg";